import SplitHero from "../Generic/SplitHero";

const ProjectsHero = () => {
  return (
    <SplitHero
      title="WISE PROJECTS"
      description={
        <>
          WiSE Projects are where ideas turn into action and learning creates
          real-world impact. Members can collaborate on industry-relevant
          problem statements or propose projects of their own—shaping
          initiatives that matter within the semiconductor ecosystem.
          <br />
          <br />
          Once approved, WiSE actively supports each project with access to
          mentors, resources, and a collaborative community—enabling execution
          from concept to completion.
        </>
      }
      imageSrc="/assets/projects/projectsherobg.png"
      imagePosition="right"
      //cardOffsetDesktop="-4%"
      variant="split"
    />
  );
};

export default ProjectsHero;
